import React from 'react';
import { Grid } from 'style';
import { DataStoreService } from 'utils';
import ListComponent, { ItemComponent, ListWrapper } from '../common/lists/lists.component.v2';
import CaseComponent from './case.component';
import Emitter from '../../utils/emitter';
import GA from '../../utils/ga'


function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

class CaseListComponent extends ListComponent {
  constructor(props) {
    super(props);

    this.state = {
      cases: null
    };
    this.setCases = this.setCases.bind(this);
  }
  componentWillUnmount(){ 
    if (Emitter){
      Emitter.removeListener('filterByService', this.setCases);
    }
  }
  componentDidMount() {
    Emitter.on('filterByService', this.setCases); 
    this.setCases('');
  }
  setServiceFilter(service){
    Emitter.emit('filterByService', service); 
    GA.serviceFilter(service);
  }
  setCases(service){
    if (service !== ''){
      this.setState(() => ({
        cases: DataStoreService.getCasesByService(service),
      }));
    }else{
      this.setState(() => ({
        cases: DataStoreService.getCases(),
      }));
    }
  }

  render() {
    const {
      cases
    } = this.state;
    return cases ? (
      <div className="wrapper">
      <Grid.Overflow className="container-fluid">
        <div id="CaseList" className="row"> {
            cases.edges.map((data, i) => (<ItemComponent itemsPerRow={3}
              key={
                data.node.slug
              }
              onChange={
                this.onVisible
              }
              isVisible={ i<3 ? true: false }>
              <CaseComponent {...data.node} even={i % 2 == 0} setServiceFilter={this.setServiceFilter.bind(this)} /> </ItemComponent>
            ))
          }
          <ItemComponent itemsPerRow={3} />
          <ItemComponent itemsPerRow={3} />
        </div>
      </Grid.Overflow>
      </div>
    ) : (<div />
      );
  }
}


export default CaseListComponent;
